module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"檢舉/阻擋","already_blocked":"已檢舉/阻擋的貼文。","cancel":"取消","submit":"檢舉","error":"檢舉受理失敗。請確認輸入內容。"}}')
  delete Component.options._Ctor
}
